'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@morpho-org/ui-v6/utils';
import { Badge, Checkbox } from '@repo/ui';
import { CommandItem } from 'cmdk';
import { useEffect, useState } from 'react';
import type { FilterItem } from './AdvancedFilter';
import { Avatar } from '../Avatar';
import { AvatarMultichain } from '../AvatarMultichain';
interface AdvancedFilterItemProps<T> {
  item: FilterItem<T>;
  toggleItem: (value: T) => void;
}
function AdvancedFilterItem(t0) {
  const $ = _c(29);
  const {
    item,
    toggleItem
  } = t0;
  const [isChecked, setIsChecked] = useState(item.isChecked);
  let t1;
  let t2;
  if ($[0] !== item.isChecked) {
    t1 = () => {
      setIsChecked(item.isChecked);
    };
    t2 = [item.isChecked];
    $[0] = item.isChecked;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== item.value || $[4] !== toggleItem) {
    t3 = () => {
      setIsChecked(_temp);
      toggleItem(item.value);
    };
    $[3] = item.value;
    $[4] = toggleItem;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const handleCheckboxChange = t3;
  const t4 = item.id;
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = cn("gap-xs flex items-center", "px-xs py-2xs cursor-pointer rounded-lg", "h-[29px]", "data-[selected=true]:bg-accent");
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== isChecked) {
    t6 = <Checkbox checked={isChecked} onCheckedChange={_temp2} />;
    $[7] = isChecked;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== item.chain || $[10] !== item.icon || $[11] !== item.img) {
    t7 = item.icon ? <Avatar size="small" icon={item.icon} /> : item.chain ? <AvatarMultichain src={item.img ?? null} chain={item.chain} size="small" /> : item.img ? <Avatar size="small" src={item.img} /> : null;
    $[9] = item.chain;
    $[10] = item.icon;
    $[11] = item.img;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== item.label) {
    t8 = <span className="text-foreground truncate text-xs leading-none whitespace-nowrap">{item.label}</span>;
    $[13] = item.label;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== item.tag) {
    t9 = item.tag && <Badge variant="info" size="sm" className="ml-2xs">{item.tag}</Badge>;
    $[15] = item.tag;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t7 || $[18] !== t8 || $[19] !== t9) {
    t10 = <div className="gap-2xs flex min-w-0 flex-1 items-center overflow-hidden">{t7}{t8}{t9}</div>;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== item.count) {
    t11 = item.count != null && <span className="text-muted-foreground ml-auto text-xs leading-none whitespace-nowrap">{item.count.toLocaleString("en-US")}</span>;
    $[21] = item.count;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== handleCheckboxChange || $[24] !== item.id || $[25] !== t10 || $[26] !== t11 || $[27] !== t6) {
    t12 = <CommandItem value={t4} onSelect={handleCheckboxChange} className={t5}>{t6}{t10}{t11}</CommandItem>;
    $[23] = handleCheckboxChange;
    $[24] = item.id;
    $[25] = t10;
    $[26] = t11;
    $[27] = t6;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  return t12;
}
function _temp2() {}
function _temp(prev) {
  return !prev;
}
export default AdvancedFilterItem;